/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  makeStyles,
  lighten,
  withStyles,
  useTheme
} from "@material-ui/core/styles";
import {
  TextField,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Toolbar,
  Typography,
  Tooltip,
  IconButton,
  TableSortLabel,
  TablePagination,
  Switch,
  FormControlLabel,
  TableFooter
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import {Notice, KTCodeExample} from "../../_metronic/_partials/controls";
import * as auth from "../modules/Auth/_redux/inOutHistoryRedux";
import { getInOutHistory } from "../modules/Auth/_redux/inOutHistoryCrud";

import * as moment from 'moment';

export const toAbsoluteUrl = pathname => process.env.PUBLIC_URL + pathname;

const useStyles4 = makeStyles(theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  }
}));

const StyledTableCell4 = withStyles(theme => ({
  head: {
    backgroundColor: '#298BA8', // theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow4 = withStyles(theme => ({ 
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default
    }
  }
}))(TableRow);

// Example 5
const useStyles52 = makeStyles(theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3)
  },
  table: {
    minWidth: 500
  },
  tableWrapper: {
    overflowX: "auto"
  }
}));

const useStyles51 = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(2.5)
  }
}));

function TablePaginationActions5(props) {
  const classes = useStyles51();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  function handleFirstPageButtonClick(event) {
    onChangePage(event, 0);
  }

  function handleBackButtonClick(event) {
    onChangePage(event, page - 1);
  }

  function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
  }

  function handleLastPageButtonClick(event) {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  }

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="First Page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="Previous Page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Next Page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Last Page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions5.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};

var rows5 = [

  // createData5('A001', '김경섭', '1F_B001', '3928049', '성공', '카드', '-', '2021-03-25', '-'),
  // createData5('A002', '김경섭', '1F_B001', '3928049', '성공', '카드', '-', '2021-03-25', '-'),
  // createData5('A003', '김경섭', '1F_B001', '3928049', '성공', '카드', '-', '2021-03-25', '-'),
  // createData5('A004', '김경섭', '1F_B001', '3928049', '성공', '카드', '-', '2021-03-25', '-'),
  // createData5('A005', '김경섭', '1F_B001', '3928049', '성공', '카드', '-', '2021-03-25', '-'),
  // createData5('A006', '김경섭', '1F_B001', '3928049', '성공', '카드', '-', '2021-03-25', '-'),
  // createData5('A007', '김경섭', '1F_B001', '3928049', '성공', '카드', '-', '2021-03-25', '-'),
  // createData5('A008', '김경섭', '1F_B001', '3928049', '성공', '카드', '-', '2021-03-25', '-'),
  // createData5('A009', '김경섭', '1F_B001', '3928049', '성공', '카드', '-', '2021-03-25', '-'),
  // createData5('A010', '김경섭', '1F_B001', '3928049', '성공', '카드', '-', '2021-03-25', '-'),
  // createData5('A011', '김경섭', '1F_B001', '3928049', '성공', '카드', '-', '2021-03-25', '-'),
  
]; // .sort((a, b) => (a.calories < b.calories ? -1 : 1));


export function InOutsHistoryPage() { // TablesExamplesPage

  var m = moment();
  var _endDt = m.format('YYYY-MM-DD')
  var _startDt = m.add(-30,'days').format('YYYY-MM-DD')
  
  const [refresh, setRefresh] = React.useState('');
  const [userName, setUserName] = React.useState('');
  const [cardNo, setCardNo] = React.useState('');

  // const [name, setName] = React.useState('');

  const [startDt, setStartDt] = React.useState(_startDt);
  const [endDt, setEndDt] = React.useState(_endDt);

  function searchInOutHistory(){

    const fetchData = async () => {
      try {
        const result = await getInOutHistory();
  
        rows5 = [];
        var hists = result.data.list;
    
        for(var ii = 0; ii < hists.length; ii++) {
          var hist = hists[ii];
    
          console.log(hist)
  
          if(hist.accessDt != null && hist.accessDt != '')
            hist.accessDt = hist.accessDt.substr(0, 10) + ' ' + hist.accessDt.substr(11, 5);
          hist.name = '출입자명 #' + ii;
          hist.deviceName = '장치 #' + ii;
          rows5 = [ ...rows5, hist]
        }
        setRefresh('xxx')
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }

  function handleChangeUserName(event, newValue) {
    setUserName(newValue);
  }

  function handleChangeCardNo(event, newValue) {
    setCardNo(newValue);
  }

  const classes4 = useStyles4();
  const classes5 = useStyles52();

  const [page5, setPage5] = React.useState(0);
  const [rowsPerPage5, setRowsPerPage5] = React.useState(10);

  const emptyRows5 =
    rowsPerPage5 - Math.min(rowsPerPage5, rows5.length - page5 * rowsPerPage5);

  function handleChangePage5(event, newPage) {
    setPage5(newPage);
  }

  function handleChangeRowsPerPage5(event) {
    setRowsPerPage5(parseInt(event.target.value, 10));
  }

  useEffect(() => {
    searchInOutHistory();
  })


  return ( 
    <>

      <div className="row">
        <div className="col-md-2">

        <TextField
            id="standard-name"
            label="출입자이름"
            className={classes4.textField}
            onChange={handleChangeUserName}
            margin="normal"
          />

        </div> 
        <div className="col-md-2">
          <TextField
            id="outlined-name"
            label="카드번호"
            className={classes4.textField}
            onChange={handleChangeCardNo}
            margin="normal"
          />
        </div>

        <div className="col-md-2">
          <TextField
            id="date"
            label="시작일"
            type="date"
            defaultValue={startDt}
            className={classes4.textField}
            InputLabelProps={{
              shrink: true,
            }}
            style={{
              position: 'absolute',
              bottom: '8px'
            }}
          />
          </div>
          <div className="col-md-2">
          <TextField
            id="date"
            label="종료일"
            type="date"
            defaultValue={endDt}
            className={classes4.textField}
            InputLabelProps={{
              shrink: true,
            }}
            style={{
              position: 'absolute',
              bottom: '8px'
            }}
          />

        </div>
          <div className="col-md-4">
          <Button variant="contained" color="secondary" className={classes4.button}
            onClick={searchInOutHistory}
            style={{
              position: 'absolute',
              bottom: '8px',
              right: '18px'
            }}>
            검색
            <SearchIcon className={classes4.rightIcon} />
          </Button>
          </div>
        </div>

        {/*<div className="separator separator-dashed my-7"></div>*/}
        <div className="row">
        <div className="col-md-12">

            <Paper className={classes5.root}>
              <div className={classes5.tableWrapper}>
                <Table className={classes5.table}>
                  
                <TableHead>
                  <TableRow>

                    <StyledTableCell4 style={{width: '100px'}} align="center">출입자번호</StyledTableCell4>
                    <StyledTableCell4 align="center">이름</StyledTableCell4>
                    <StyledTableCell4 align="center">장치명</StyledTableCell4>
                    <StyledTableCell4 align="center">카드번호</StyledTableCell4>
                    <StyledTableCell4 align="center">인증결과</StyledTableCell4>
                    <StyledTableCell4 align="center">인증유형</StyledTableCell4>
                    <StyledTableCell4 align="center">출입일시</StyledTableCell4>

                    {/*
                    <StyledTableCell4>한글 이름</StyledTableCell4>
                    <StyledTableCell4 align="right">Calories</StyledTableCell4>
                    <StyledTableCell4 align="right">
                      Fat&nbsp;(g)
                    </StyledTableCell4>
                    <StyledTableCell4 align="right">
                      Carbs&nbsp;(g)
                    </StyledTableCell4>
                    <StyledTableCell4 align="right">
                      Protein&nbsp;(g)
                    </StyledTableCell4>
                    */}
                  </TableRow>
                </TableHead>
                
                  <TableBody>
                    {rows5
                      .slice(
                        page5 * rowsPerPage5,
                        page5 * rowsPerPage5 + rowsPerPage5
                      )
                      .map(row => (
                        <TableRow key={row.name}>
                          <TableCell component="th" scope="row" align="center">
                            {row.id}
                          </TableCell>

                          <TableCell align="center">{row.name}</TableCell>
                          <TableCell align="center">{row.deviceName}</TableCell>
                          <TableCell align="center">{row.cardNo}</TableCell>
                          <TableCell align="center">{row.result}</TableCell>
                          <TableCell align="center">{row.authType}</TableCell>
                          <TableCell align="center">{row.accessDt}</TableCell>

                          
                        </TableRow>
                      ))}

                    {emptyRows5 > 0 && (
                      <TableRow style={{ height: 48 * emptyRows5 }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        // rowsPerPageOptions={[5, 10, 25]}
                        colSpan={3}
                        count={rows5.length}
                        rowsPerPage={rowsPerPage5}
                        page={page5}
                        /*SelectProps={{
                          inputProps: { "aria-label": "Rows per page" },
                          native: true
                        }}*/
                        onChangePage={handleChangePage5}
                        onChangeRowsPerPage={handleChangeRowsPerPage5}
                        ActionsComponent={TablePaginationActions5}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </div>
            </Paper>
            
        </div>

      </div>
    </>
  );
}


